<template>
  <div class="currTime">
    <div>{{currTime}}</div>
    <template v-if="isShowInfo==true">
    <span>操作人：{{rename}}</span>
    <!-- <span v-if="department!=null">部门：{{department}}</span> -->
    </template>
  </div>
</template>
<script>
import { localUserInfo } from '../../static/js/utils/utility.js'
export default {
  name:'currTime',
  props:{
    isShowInfo:{
      type:Boolean,
      required: true
    }
  },
  data(){
    return {
      currTime:'',
      rename:'',
      department:''
    }
  },
  created(){
    var info = localUserInfo.getItem()
    if(info){
      this.rename = info.user_name
      this.department = info.department
    }
    this.getCurrTime()
  },
  methods:{
    getCurrTime(){
      var that = this
      setInterval(function(){   
        var date=new Date();
        var year=date.getFullYear();//当前年份
        var month=date.getMonth();//当前月份
        var data=date.getDate();//天
        var hours=date.getHours();//小时
        var minute=date.getMinutes();//分
        var second=date.getSeconds();//秒  
        that.currTime = year+'-'+that.fnW((month+1))+'-'+that.fnW(data)+' '+that.fnW(hours)+':'+that.fnW(minute)+':'+that.fnW(second)
      },1000)  
    },
    fnW(str){
      var num;
      str>=10?num=str:num="0"+str;
      return num;
    } 
  },
  watch:{
    
  }
}
</script>
<style lang="less">
.currTime{
  font-size: 0.4rem;
  text-align: right;
  line-height: 0.6rem;
  span{
    margin-left: 0.4rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/assets/currTime.vue